import { connectStaleableLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { memberInfoGuard, feedMemberInfoGuard } from 'guards/globalGuards'
import { showProfileEditFormActionCreator } from 'actions/settingsActions'
import ProfileSettingsModule, {
  ProfileSettingsModuleStateProps,
  ProfileSettingsModuleDispatchProps,
} from 'components/features/pfm/ProfileSettingsModule/ProfileSettingsModule'
import { memberInfoSelector, isMemberDataPresentSelector } from 'selectors/globalSelectors'
import { captureForgottenGuard } from 'helpers/errorHelpers'
import { createSelector } from 'reselect'
import { settingsSelector } from 'selectors/settingsSelector'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps, createOptionalRenderer } from 'tangle-shared'
import { feedMemberAvatarSelector } from 'selectors/feedImagesSelectors'

const createMapStateToProps = () => {
  const optionalRenderer = createOptionalRenderer<ProfileSettingsModuleStateProps>()

  return createSelector(
    memberInfoSelector,
    memberFeedInfoSelector,
    settingsSelector,
    feedMemberAvatarSelector,
    (member, memberFeed, { profileEditFormVisible }, avatar): OptionalRendererProps<ProfileSettingsModuleStateProps> => {
      if (!member) {
        captureForgottenGuard('ProfileSettingsModuleContainer', 'memberInfoGuard')
        return optionalRenderer.fallback()
      }

      if (!memberFeed) {
        return optionalRenderer.fallback()
      }

      const { income, address1, address2, zip5, city, housing_type } = member
      const { uid, username } = memberFeed

      return optionalRenderer.render({
        uid,
        avatar,
        username,
        income,
        housing_type,
        address1,
        address2,
        zip5,
        city,
        profileEditFormVisible,
      })
    }
  )
}

const mapDispatchToProps = {
  showProfileEditForm: showProfileEditFormActionCreator,
}

const guards: Guards = [
  createParallelGuard(memberInfoGuard, feedMemberInfoGuard),
]

const ProfileSettingsModuleOptional = connectOptionally<
  ProfileSettingsModuleStateProps, ProfileSettingsModuleDispatchProps
>(createMapStateToProps, mapDispatchToProps)(ProfileSettingsModule)

const ProfileSettingsModuleContainer = connectStaleableLoadable<
  // TODO
  {}, {}, {}, {}
>(guards, isMemberDataPresentSelector)(() => () => ({}), undefined)(ProfileSettingsModuleOptional)

export default ProfileSettingsModuleContainer
